var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgAdvertisersFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 11.4C7.73514 11.4 8.77824 11.006 9.6 10.3472V10.2C9.6 8.54315 8.25685 7.2 6.6 7.2C7.59411 7.2 8.4 6.39411 8.4 5.4C8.4 4.40589 7.59411 3.6 6.6 3.6C5.60589 3.6 4.8 4.40589 4.8 5.4C4.8 6.39411 5.60589 7.2 6.6 7.2C4.94315 7.2 3.6 8.54315 3.6 10.2V10.3472C4.42176 11.006 5.46486 11.4 6.6 11.4ZM13.2 6.6C13.2 9.16481 11.737 11.3879 9.6 12.4803C8.69992 12.9405 7.68027 13.2 6.6 13.2C5.51973 13.2 4.50008 12.9405 3.6 12.4803C3.55099 12.4553 3.50234 12.4296 3.45405 12.4034C1.39666 11.2858 0 9.10599 0 6.6C0 2.95492 2.95492 0 6.6 0C10.2451 0 13.2 2.95492 13.2 6.6ZM17.4 22.2C18.5351 22.2 19.5782 21.806 20.4 21.1472V21C20.4 19.3431 19.0569 18 17.4 18C18.3941 18 19.2 17.1941 19.2 16.2C19.2 15.2059 18.3941 14.4 17.4 14.4C16.4059 14.4 15.6 15.2059 15.6 16.2C15.6 17.1941 16.4059 18 17.4 18C15.7431 18 14.4 19.3431 14.4 21V21.1472C15.2218 21.806 16.2649 22.2 17.4 22.2ZM24 17.4C24 19.9648 22.537 22.1879 20.4 23.2803C19.4999 23.7405 18.4803 24 17.4 24C16.3197 24 15.3001 23.7405 14.4 23.2803C14.351 23.2553 14.3023 23.2296 14.254 23.2034C12.1967 22.0858 10.8 19.906 10.8 17.4C10.8 13.7549 13.7549 10.8 17.4 10.8C21.0451 10.8 24 13.7549 24 17.4ZM15 5.4H18C19.6569 5.4 21 6.74315 21 8.4V10.2H19.8V8.4C19.8 7.40589 18.9941 6.6 18 6.6H15V5.4ZM6 19.8H9V18.6H6C5.00589 18.6 4.2 17.7941 4.2 16.8V15H3V16.8C3 18.4569 4.34315 19.8 6 19.8Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisersFilled);
export default __webpack_public_path__ + "static/media/advertisersFilled.beac0cb9c359610af1ba840b44550e3f.svg";
export { ForwardRef as ReactComponent };